export interface StatusProperties {
  waited?: boolean;
  moved?: boolean;
  hit?: boolean;
}

export const makeStatus = (): StatusProperties => ({
  waited: false,
  moved: false,
  hit: false,
});
